import request from '../../../api/request';
import { IdentificationTypeResponse } from '../../TeacherManagement/TeacherActivation/types';
import { StudentFileShowResponse } from '../types';

const STUDENT_INFO = {
  GET_POSTULANT: (studentId: string | number) =>
    `maintainers-portal/student-management/student-file/show/${studentId}`,
  UPDATE_POSTULANT_PHOTO: (postulantId: string | number) =>
    `maintainers-portal/student-management/student-file/photo/${postulantId}`,
  UPDATE_POSTULANT: (postulantId: string | number) =>
    `maintainers-portal/student-management/student-file/update/${postulantId}`,
  IDENTIFICATION_TYPES:
    'maintainers-portal/student-management/student-file/identification-types',
  GET_ASYNC_OPTIONS_FIELDS:
    'maintainers-portal/student-management/student-file/async-options-fields',
};

export const getPostulant = (id: number | string) => {
  return request<StudentFileShowResponse>(STUDENT_INFO.GET_POSTULANT(id));
};

export const savePostulant = (
  id: number | string,
  body: { responses: any; source?: string },
) => {
  return request(STUDENT_INFO.UPDATE_POSTULANT(id), {
    method: 'post',
    data: body,
  });
};

export const savePostulantPhoto = (id: number | string, photo?: File) => {
  const formData = new FormData();
  if (photo) {
    formData.append('photo', photo);
  }
  return request(STUDENT_INFO.UPDATE_POSTULANT_PHOTO(id), {
    method: 'post',
    data: formData,
  });
};

export const getIdentificationTypes = () => {
  return request<IdentificationTypeResponse>(STUDENT_INFO.IDENTIFICATION_TYPES);
};
